const defaultApiUrl = import.meta.env.PROD ? 'https://api.4mal.kz/api' : 'http://localhost:5036/api';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || defaultApiUrl;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info',
} as const;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    SEND_VERIFICATION_CODE: '/auth/send-verification-code',
    VERIFY_CODE_AND_REGISTER: '/auth/verify-code-and-register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    REFRESH_TOKEN: '/auth/refresh-token',
    VERIFY_TOKEN: '/auth/verify-token',
  },
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    FARMS: '/admin/farms',
    ANIMALS: '/admin/animals',
  },
  REGION: {
    LIST: '/region',
    HIERARCHY: '/region/hierarchy',
    ROOT: '/region/root',
    CHILDREN: '/region/children',
    SEARCH: '/region/search',
  },
  INSEMINATOR_BONITER: {
    ALL: '/inseminatorboniter',
    BONITERS: '/inseminatorboniter/boniters',
    INSEMINATORS: '/inseminatorboniter/inseminators',
    TRANSPLANTOLOGISTS: '/inseminatorboniter/transplantologists',
  },
  DNA_LAB: '/dnalab',
  AUCTION: '/auction',
  FEEDING_AREA: '/feedingarea',
  ANIMAL_TYPE: '/animaltype',
  BREED: '/breed',
  ANIMAL_STATUS: '/animalstatus',
} as const;
